__turbopack_context__.v({
  "modalContent": "WfodcG_modalContent",
  "modalPortrait": "WfodcG_modalPortrait",
  "watchPill": "WfodcG_watchPill",
});
